import { render, staticRenderFns } from "./TestAnalysis.vue?vue&type=template&id=13fbd670&scoped=true&"
import script from "./TestAnalysis.vue?vue&type=script&lang=js&"
export * from "./TestAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./TestAnalysis.vue?vue&type=style&index=0&id=13fbd670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fbd670",
  null
  
)

export default component.exports